import loadable from 'react-loadable-visibility/loadable-components'; 

// Do not modify anything within the `<auto-generated-imports />` comments.
// The content within those comments is automatically generated by
// the `/scripts/generate-component-factory.js` script.

// <auto-generated-imports>


import {
AccordionCombo,
AccordionFAQ,
AccordionGeneric,
AccordionSteps,
Articles,
ArticlesFeatureCarousel,
FeaturedBanner,
SystemMessageBanner,
GeneralCardCompleteRound,
GeneralCardIconCards,
GeneralCardImageCards,
RichText,
OfferAndDeal,
ListingOffersAndDeals,
TabsHorizontal,
StickyFooter,
OfferAndDealDetails,
OffersAndDealsTopPicks,
HighlightBanner,
Curators,
SurpriseWizard,
CategoryTiles,
CTAVariation,
InteractiveBanner,
InteractiveBannerHero,
InteractiveMap,
OverlayTiles,
TabsCarouselComponentListing,
StepCards,
ComparisonTable,
SectionDetail,
WizardCategories,
FeatureCardsList,
Events,
EventsFeatureCarousel,
FunFactsContainer,
Itineraries,
VideoTile,
NewsCarousel,
NewsPRs,
POIs,
CTAsList,
SectionIntro,
Statistics,
StatisticsContainer,
CategoriesChildren,
CategoriesSiblings,
Tabs,
TabsWithAccordion,
MultipleQuoteTestimonial,
TestimonialCarousel,
CuratorHeader,
EventHeader,
HeaderArticle1,
HeaderCarousel,
HeaderGenericPrimary,
HeaderGenericPrimaryLeisure,
HeaderGenericSecondary,
HeaderGenericTertiary,
HeaderListingPage,
HeaderListingPagePersonalizable,
HeaderMedia,
WhatsonHeader,
HeroPrimary,
HeroSecondary,
InsightsHeader,
ItineraryCoverHeader,
ItineraryDayViewHeader,
PersonalizablePrimaryHeader,
POIHeader,
KDramaMap,
ItineraryPOIsOverview,
TimelineNavigationCompact,
AnnouncementBanner,
WidgetCurrencyConverter,
AnchorItem,
AnchorList,
AnimatedImageSlider,
InteractiveGoogleMap,
Loader,
CampaignScriptGenerator,
CardMultiple,
CodeSnippet,
ContactCustomerCare,
CommonPageContainer,
GenericPageContainer,
DAcApplication,
DAcApplicationUploadDocuments,
DAcConfirmation,
DAcCreateAccount,
DAcDashboard,
DAcLogin,
DAcRegistration,
DynamicPopup,
EventsWidget,
FlyDubaiWidget,
HeaderForActivationPage,
IdentifyTravelers,
InformationalHeroCards,
ListingServicesHeader,
AccountAuthorization,
AccountEditYourInterests,
DeleteAccount,
MainText,
ManagedWidget,
MultifunctionalCards,
PopularCuisines,
RecommendationListing,
RedirectToReturnUrl,
RestaurantsCarousel,
RestaurantsHeadingAndContentBlock,
RestaurantsListing,
RestaurantsNavigation,
RestaurantsSmallBanner,
RichTextBubble,
SchemaSnippet,
ScrollToBlock,
SearchRestaurants,
SharedChannelsBreadcrumb,
SharedChannelsCarousel,
SharedChannelsListing,
SkipContentButtons,
SurpriseMeForm,
UnbelievableSummerDeals,
VenueHeader,
VideoScriptGenerator,
WeatherWidget
} from '@dtcm/ui-components';
const components = new Map();
components.set('AccordionCombo', AccordionCombo);
components.set('AccordionFAQ', AccordionFAQ);
components.set('AccordionGeneric', AccordionGeneric);
components.set('AccordionSteps', AccordionSteps);
components.set('Articles', Articles);
components.set('ArticlesFeatureCarousel', ArticlesFeatureCarousel);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('CuratorArticles', loadable(() => import(/* webpackChunkName: "CuratorArticles" */'@dtcm/ui-components/dist/components/02_CuratorArticles/CuratorArticles')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('AnchorNavigation', loadable(() => import(/* webpackChunkName: "AnchorNavigation" */'@dtcm/ui-components/dist/components/03_AnchorNavigation/AnchorNavigation')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('AudioPlayer', loadable(() => import(/* webpackChunkName: "AudioPlayer" */'@dtcm/ui-components/dist/components/04_Audio/AudioPlayer')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('BannerLarge', loadable(() => import(/* webpackChunkName: "BannerLarge" */'@dtcm/ui-components/dist/components/05_BannerLarge/BannerLarge')))
components.set('FeaturedBanner', FeaturedBanner);
components.set('SystemMessageBanner', SystemMessageBanner);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('BannerSmall', loadable(() => import(/* webpackChunkName: "BannerSmall" */'@dtcm/ui-components/dist/components/05_BannerSmall/BannerSmall')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('HeatMap', loadable(() => import(/* webpackChunkName: "HeatMap" */'@dtcm/ui-components/dist/components/06_HeatMap/HeatMap')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Table', loadable(() => import(/* webpackChunkName: "Table" */'@dtcm/ui-components/dist/components/06_Table/Table')))
components.set('GeneralCardCompleteRound', GeneralCardCompleteRound);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('GeneralCardIcon', loadable(() => import(/* webpackChunkName: "GeneralCardIcon" */'@dtcm/ui-components/dist/components/07_GeneralCardIcon/GeneralCardIcon')))
components.set('GeneralCardIconCards', GeneralCardIconCards);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('GeneralCardIconMultiple', loadable(() => import(/* webpackChunkName: "GeneralCardIconMultiple" */'@dtcm/ui-components/dist/components/07_GeneralCardIconMultiple/GeneralCardIconMultiple')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('GeneralCardImage', loadable(() => import(/* webpackChunkName: "GeneralCardImage" */'@dtcm/ui-components/dist/components/07_GeneralCardImage/GeneralCardImage')))
components.set('GeneralCardImageCards', GeneralCardImageCards);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('GeneralCardImageMultiple', loadable(() => import(/* webpackChunkName: "GeneralCardImageMultiple" */'@dtcm/ui-components/dist/components/07_GeneralCardImageMultiple/GeneralCardImageMultiple')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('SubcategoriesCompleteMultiple', loadable(() => import(/* webpackChunkName: "SubcategoriesCompleteMultiple" */'@dtcm/ui-components/dist/components/07_SubcategoriesCompleteMultiple/SubcategoriesCompleteMultiple')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ContactCard', loadable(() => import(/* webpackChunkName: "ContactCard" */'@dtcm/ui-components/dist/components/08_ContactCard/ContactCard')))
components.set('RichText', RichText);
components.set('OfferAndDeal', OfferAndDeal);
components.set('ListingOffersAndDeals', ListingOffersAndDeals);
components.set('TabsHorizontal', TabsHorizontal);
components.set('StickyFooter', StickyFooter);
components.set('OfferAndDealDetails', OfferAndDealDetails);
components.set('OffersAndDealsTopPicks', OffersAndDealsTopPicks);
components.set('HighlightBanner', HighlightBanner);
components.set('Curators', Curators);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ProfileCards', loadable(() => import(/* webpackChunkName: "ProfileCards" */'@dtcm/ui-components/dist/components/10_ProfileCards/ProfileCards')))
components.set('SurpriseWizard', SurpriseWizard);
components.set('CategoryTiles', CategoryTiles);
components.set('CTAVariation', CTAVariation);
components.set('InteractiveBanner', InteractiveBanner);
components.set('InteractiveBannerHero', InteractiveBannerHero);
components.set('InteractiveMap', InteractiveMap);
components.set('OverlayTiles', OverlayTiles);
components.set('TabsCarouselComponentListing', TabsCarouselComponentListing);
components.set('StepCards', StepCards);
components.set('ComparisonTable', ComparisonTable);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Download', loadable(() => import(/* webpackChunkName: "Download" */'@dtcm/ui-components/dist/components/12_Download/Download')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('DownloadSingle', loadable(() => import(/* webpackChunkName: "DownloadSingle" */'@dtcm/ui-components/dist/components/12_DownloadSingle/DownloadSingle')))
components.set('SectionDetail', SectionDetail);
components.set('WizardCategories', WizardCategories);
components.set('FeatureCardsList', FeatureCardsList);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Feedback', loadable(() => import(/* webpackChunkName: "Feedback" */'@dtcm/ui-components/dist/components/138_Feedback/Feedback')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('CuratorEvents', loadable(() => import(/* webpackChunkName: "CuratorEvents" */'@dtcm/ui-components/dist/components/15_CuratorEvents/CuratorEvents')))
components.set('Events', Events);
components.set('EventsFeatureCarousel', EventsFeatureCarousel);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('EloquaForm', loadable(() => import(/* webpackChunkName: "EloquaForm" */'@dtcm/ui-components/dist/components/19_EloquaForm/EloquaForm')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('CTABlock', loadable(() => import(/* webpackChunkName: "CTABlock" */'@dtcm/ui-components/dist/components/20_CTABlock/CTABlock')))
components.set('FunFactsContainer', FunFactsContainer);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('FunFactItem', loadable(() => import(/* webpackChunkName: "FunFactItem" */'@dtcm/ui-components/dist/components/21_FunFactsItem/FunFactItem')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('CuratorItineraries', loadable(() => import(/* webpackChunkName: "CuratorItineraries" */'@dtcm/ui-components/dist/components/26_CuratorItineraries/CuratorItineraries')))
components.set('Itineraries', Itineraries);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('MediaCarousel', loadable(() => import(/* webpackChunkName: "MediaCarousel" */'@dtcm/ui-components/dist/components/28_MediaCarousel/MediaCarousel')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('MediaGrid', loadable(() => import(/* webpackChunkName: "MediaGrid" */'@dtcm/ui-components/dist/components/28_MediaGrid/MediaGrid')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('MediaImage', loadable(() => import(/* webpackChunkName: "MediaImage" */'@dtcm/ui-components/dist/components/28_MediaImage/MediaImage')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('MediaImage360', loadable(() => import(/* webpackChunkName: "MediaImage360" */'@dtcm/ui-components/dist/components/28_MediaImage360/MediaImage360')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('MediaVideo', loadable(() => import(/* webpackChunkName: "MediaVideo" */'@dtcm/ui-components/dist/components/28_MediaVideo/MediaVideo')))
components.set('VideoTile', VideoTile);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Login', loadable(() => import(/* webpackChunkName: "Login" */'@dtcm/ui-components/dist/components/30_NavigationBar/Login')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Login', loadable(() => import(/* webpackChunkName: "Login" */'@dtcm/ui-components/dist/components/30_SCNavigationBar/Login')))
components.set('NewsCarousel', NewsCarousel);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('NewsInsights', loadable(() => import(/* webpackChunkName: "NewsInsights" */'@dtcm/ui-components/dist/components/31_NewsInsights/NewsInsights')))
components.set('NewsPRs', NewsPRs);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('NewsletterFormSection', loadable(() => import(/* webpackChunkName: "NewsletterFormSection" */'@dtcm/ui-components/dist/components/32_NewsletterForm/NewsletterFormSection')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Partners', loadable(() => import(/* webpackChunkName: "Partners" */'@dtcm/ui-components/dist/components/33_Partners/Partners')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('CuratorPOIs', loadable(() => import(/* webpackChunkName: "CuratorPOIs" */'@dtcm/ui-components/dist/components/34_CuratorPOIs/CuratorPOIs')))
components.set('POIs', POIs);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('PracticalInformation', loadable(() => import(/* webpackChunkName: "PracticalInformation" */'@dtcm/ui-components/dist/components/35_PracticalInformation/PracticalInformation')))
components.set('CTAsList', CTAsList);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('QuickLinks', loadable(() => import(/* webpackChunkName: "QuickLinks" */'@dtcm/ui-components/dist/components/36_QuickLinks/QuickLinks')))
components.set('SectionIntro', SectionIntro);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('DetailsCardService', loadable(() => import(/* webpackChunkName: "DetailsCardService" */'@dtcm/ui-components/dist/components/44_DetailsCardService/DetailsCardService')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Deals', loadable(() => import(/* webpackChunkName: "Deals" */'@dtcm/ui-components/dist/components/44_TravelDeals/Deals')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ListingTradeEvents', loadable(() => import(/* webpackChunkName: "ListingTradeEvents" */'@dtcm/ui-components/dist/components/44_TravelDeals/ListingTradeEvents')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ListingVendors', loadable(() => import(/* webpackChunkName: "ListingVendors" */'@dtcm/ui-components/dist/components/44_TravelDeals/ListingVendors')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('TravelDeals', loadable(() => import(/* webpackChunkName: "TravelDeals" */'@dtcm/ui-components/dist/components/44_TravelDeals/TravelDeals')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('SocialSharing', loadable(() => import(/* webpackChunkName: "SocialSharing" */'@dtcm/ui-components/dist/components/45_SocialSharing/SocialSharing')))
components.set('Statistics', Statistics);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('StatisticsBigNumbers', loadable(() => import(/* webpackChunkName: "StatisticsBigNumbers" */'@dtcm/ui-components/dist/components/46_StatisticsBigNumbers/StatisticsBigNumbers')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('StatisticsComparative', loadable(() => import(/* webpackChunkName: "StatisticsComparative" */'@dtcm/ui-components/dist/components/46_StatisticsComparative/StatisticsComparative')))
components.set('StatisticsContainer', StatisticsContainer);
components.set('CategoriesChildren', CategoriesChildren);
components.set('CategoriesSiblings', CategoriesSiblings);
components.set('Tabs', Tabs);
components.set('TabsWithAccordion', TabsWithAccordion);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Tags', loadable(() => import(/* webpackChunkName: "Tags" */'@dtcm/ui-components/dist/components/50_Tags/Tags')))
components.set('MultipleQuoteTestimonial', MultipleQuoteTestimonial);
components.set('TestimonialCarousel', TestimonialCarousel);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('TestimonialMedia', loadable(() => import(/* webpackChunkName: "TestimonialMedia" */'@dtcm/ui-components/dist/components/51_TestimonialMedia/TestimonialMedia')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('TestimonialMultipleMedia', loadable(() => import(/* webpackChunkName: "TestimonialMultipleMedia" */'@dtcm/ui-components/dist/components/51_TestimonialMultipleMedia/TestimonialMultipleMedia')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('TestimonialQuote', loadable(() => import(/* webpackChunkName: "TestimonialQuote" */'@dtcm/ui-components/dist/components/51_TestimonialQuote/TestimonialQuote')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('TestimonialStatement', loadable(() => import(/* webpackChunkName: "TestimonialStatement" */'@dtcm/ui-components/dist/components/51_TestimonialStatement/TestimonialStatement')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('UserGeneratedContent', loadable(() => import(/* webpackChunkName: "UserGeneratedContent" */'@dtcm/ui-components/dist/components/53_UserGeneratedContent/UserGeneratedContent')))
components.set('CuratorHeader', CuratorHeader);
components.set('EventHeader', EventHeader);
components.set('HeaderArticle1', HeaderArticle1);
components.set('HeaderCarousel', HeaderCarousel);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('HeaderContextImage', loadable(() => import(/* webpackChunkName: "HeaderContextImage" */'@dtcm/ui-components/dist/components/57_HeaderContextImage/HeaderContextImage')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('HeaderGenericLegislation', loadable(() => import(/* webpackChunkName: "HeaderGenericLegislation" */'@dtcm/ui-components/dist/components/57_HeaderGenericLegislation/HeaderGenericLegislation')))
components.set('HeaderGenericPrimary', HeaderGenericPrimary);
components.set('HeaderGenericPrimaryLeisure', HeaderGenericPrimaryLeisure);
components.set('HeaderGenericSecondary', HeaderGenericSecondary);
components.set('HeaderGenericTertiary', HeaderGenericTertiary);
components.set('HeaderListingPage', HeaderListingPage);
components.set('HeaderListingPagePersonalizable', HeaderListingPagePersonalizable);
components.set('HeaderMedia', HeaderMedia);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('HeaderMedia360', loadable(() => import(/* webpackChunkName: "HeaderMedia360" */'@dtcm/ui-components/dist/components/57_HeaderMedia360/HeaderMedia360')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('HeaderPressRelease', loadable(() => import(/* webpackChunkName: "HeaderPressRelease" */'@dtcm/ui-components/dist/components/57_HeaderPressRelease/HeaderPressRelease')))
components.set('WhatsonHeader', WhatsonHeader);
components.set('HeroPrimary', HeroPrimary);
components.set('HeroSecondary', HeroSecondary);
components.set('InsightsHeader', InsightsHeader);
components.set('ItineraryCoverHeader', ItineraryCoverHeader);
components.set('ItineraryDayViewHeader', ItineraryDayViewHeader);
components.set('PersonalizablePrimaryHeader', PersonalizablePrimaryHeader);
components.set('POIHeader', POIHeader);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ServicesHeader', loadable(() => import(/* webpackChunkName: "ServicesHeader" */'@dtcm/ui-components/dist/components/57_ServicesHeader/ServicesHeader')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('MediaAndCopy', loadable(() => import(/* webpackChunkName: "MediaAndCopy" */'@dtcm/ui-components/dist/components/58_MediaAndCopy/MediaAndCopy')))
components.set('KDramaMap', KDramaMap);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Map', loadable(() => import(/* webpackChunkName: "Map" */'@dtcm/ui-components/dist/components/60_Map/Map')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('NeighborhoodsMap', loadable(() => import(/* webpackChunkName: "NeighborhoodsMap" */'@dtcm/ui-components/dist/components/60_NeighborhoodsMap/NeighborhoodsMap')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('BottomNavigation', loadable(() => import(/* webpackChunkName: "BottomNavigation" */'@dtcm/ui-components/dist/components/61_BottomNavigation/BottomNavigation')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ItineraryBottomNavigation', loadable(() => import(/* webpackChunkName: "ItineraryBottomNavigation" */'@dtcm/ui-components/dist/components/61_ItineraryBottomNavigation/ItineraryBottomNavigation')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Timeline', loadable(() => import(/* webpackChunkName: "Timeline" */'@dtcm/ui-components/dist/components/62_Timeline/Timeline')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('CuratorMatcher', loadable(() => import(/* webpackChunkName: "CuratorMatcher" */'@dtcm/ui-components/dist/components/65_CuratorMatcher/CuratorMatcher')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('VisaRequirementsWizard', loadable(() => import(/* webpackChunkName: "VisaRequirementsWizard" */'@dtcm/ui-components/dist/components/65_VisaRequirementsWizard/VisaRequirementsWizard')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('WizardTraining', loadable(() => import(/* webpackChunkName: "WizardTraining" */'@dtcm/ui-components/dist/components/65_WizardTraining/WizardTraining')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ItineraryOverview', loadable(() => import(/* webpackChunkName: "ItineraryOverview" */'@dtcm/ui-components/dist/components/68_ItineraryOverview/ItineraryOverview')))
components.set('ItineraryPOIsOverview', ItineraryPOIsOverview);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('TimelineNavigation', loadable(() => import(/* webpackChunkName: "TimelineNavigation" */'@dtcm/ui-components/dist/components/69_TimelineNavigation/TimelineNavigation')))
components.set('TimelineNavigationCompact', TimelineNavigationCompact);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ItineraryFoodBreak', loadable(() => import(/* webpackChunkName: "ItineraryFoodBreak" */'@dtcm/ui-components/dist/components/70_ItineraryFoods/ItineraryFoodBreak')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('AutoDownload', loadable(() => import(/* webpackChunkName: "AutoDownload" */'@dtcm/ui-components/dist/components/71_AutoDownload/AutoDownload')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('IndexList', loadable(() => import(/* webpackChunkName: "IndexList" */'@dtcm/ui-components/dist/components/75_IndexList/IndexList')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('EditableListicleEvents', loadable(() => import(/* webpackChunkName: "EditableListicleEvents" */'@dtcm/ui-components/dist/components/77_EditableListicleEvents/EditableListicleEvents')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('EditableListiclePOIs', loadable(() => import(/* webpackChunkName: "EditableListiclePOIs" */'@dtcm/ui-components/dist/components/77_EditableListiclePOIs/EditableListiclePOIs')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ListicleEvents', loadable(() => import(/* webpackChunkName: "ListicleEvents" */'@dtcm/ui-components/dist/components/77_ListicleEvents/ListicleEvents')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ListicleItem', loadable(() => import(/* webpackChunkName: "ListicleItem" */'@dtcm/ui-components/dist/components/77_ListicleItem/ListicleItem')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ListicleMedia', loadable(() => import(/* webpackChunkName: "ListicleMedia" */'@dtcm/ui-components/dist/components/77_ListicleMedia/ListicleMedia')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ListiclePOIs', loadable(() => import(/* webpackChunkName: "ListiclePOIs" */'@dtcm/ui-components/dist/components/77_ListiclePOIs/ListiclePOIs')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('CuratorSection', loadable(() => import(/* webpackChunkName: "CuratorSection" */'@dtcm/ui-components/dist/components/78_CuratorSection/CuratorSection')))
components.set('AnnouncementBanner', AnnouncementBanner);
components.set('WidgetCurrencyConverter', WidgetCurrencyConverter);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('AccountNavigation', loadable(() => import(/* webpackChunkName: "AccountNavigation" */'@dtcm/ui-components/dist/components/AccountNavigation/AccountNavigation')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('AccountOverview', loadable(() => import(/* webpackChunkName: "AccountOverview" */'@dtcm/ui-components/dist/components/AccountOverview/AccountOverview')))
components.set('AnchorItem', AnchorItem);
components.set('AnchorList', AnchorList);
components.set('AnimatedImageSlider', AnimatedImageSlider);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Form', loadable(() => import(/* webpackChunkName: "Form" */'@dtcm/ui-components/dist/components/atoms/Forms/Form')))
components.set('InteractiveGoogleMap', InteractiveGoogleMap);
components.set('Loader', Loader);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Video', loadable(() => import(/* webpackChunkName: "Video" */'@dtcm/ui-components/dist/components/atoms/Video/Video')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('BrightcoveVideoBanner', loadable(() => import(/* webpackChunkName: "BrightcoveVideoBanner" */'@dtcm/ui-components/dist/components/BrightcoveVideoBanner/index')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('BrightcoveVideoDetails', loadable(() => import(/* webpackChunkName: "BrightcoveVideoDetails" */'@dtcm/ui-components/dist/components/BrightcoveVideoDetails/index')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('BrightcoveVideoDetailsHeader', loadable(() => import(/* webpackChunkName: "BrightcoveVideoDetailsHeader" */'@dtcm/ui-components/dist/components/BrightcoveVideoDetailsHeader/index')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('BrightcoveVideos', loadable(() => import(/* webpackChunkName: "BrightcoveVideos" */'@dtcm/ui-components/dist/components/BrightcoveVideos/index')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('BrightcoveVideosHeader', loadable(() => import(/* webpackChunkName: "BrightcoveVideosHeader" */'@dtcm/ui-components/dist/components/BrightcoveVideosHeader/index')))
components.set('CampaignScriptGenerator', CampaignScriptGenerator);
components.set('CardMultiple', CardMultiple);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Chart', loadable(() => import(/* webpackChunkName: "Chart" */'@dtcm/ui-components/dist/components/Chart/Chart')))
components.set('CodeSnippet', CodeSnippet);
components.set('ContactCustomerCare', ContactCustomerCare);
components.set('CommonPageContainer', CommonPageContainer);
components.set('GenericPageContainer', GenericPageContainer);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('CookiePolicy', loadable(() => import(/* webpackChunkName: "CookiePolicy" */'@dtcm/ui-components/dist/components/CookiePolicy/CookiePolicy')))
components.set('DAcApplication', DAcApplication);
components.set('DAcApplicationUploadDocuments', DAcApplicationUploadDocuments);
components.set('DAcConfirmation', DAcConfirmation);
components.set('DAcCreateAccount', DAcCreateAccount);
components.set('DAcDashboard', DAcDashboard);
components.set('DAcLogin', DAcLogin);
components.set('DAcRegistration', DAcRegistration);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('DashboardHeader', loadable(() => import(/* webpackChunkName: "DashboardHeader" */'@dtcm/ui-components/dist/components/DashboardHeader/DashboardHeader')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('DynamicListingComponent', loadable(() => import(/* webpackChunkName: "DynamicListingComponent" */'@dtcm/ui-components/dist/components/DynamicListingComponent/DynamicListingComponent')))
components.set('DynamicPopup', DynamicPopup);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('EmiratesFlightWidget', loadable(() => import(/* webpackChunkName: "EmiratesFlightWidget" */'@dtcm/ui-components/dist/components/EmiratesFlightWidget/index')))
components.set('EventsWidget', EventsWidget);
components.set('FlyDubaiWidget', FlyDubaiWidget);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('FrontendSystemRedirect', loadable(() => import(/* webpackChunkName: "FrontendSystemRedirect" */'@dtcm/ui-components/dist/components/FrontendSystemRedirect/FrontendSystemRedirect')))
components.set('HeaderForActivationPage', HeaderForActivationPage);
components.set('IdentifyTravelers', IdentifyTravelers);
components.set('InformationalHeroCards', InformationalHeroCards);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Listing', loadable(() => import(/* webpackChunkName: "Listing" */'@dtcm/ui-components/dist/components/Listing/Listing')))
components.set('ListingServicesHeader', ListingServicesHeader);
components.set('AccountAuthorization', AccountAuthorization);
components.set('AccountEditYourInterests', AccountEditYourInterests);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ChangePassword', loadable(() => import(/* webpackChunkName: "ChangePassword" */'@dtcm/ui-components/dist/components/Login/ChangePassword')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('TwitterRedirect', loadable(() => import(/* webpackChunkName: "TwitterRedirect" */'@dtcm/ui-components/dist/components/Login/components/TwitterRedirect')))
components.set('DeleteAccount', DeleteAccount);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('EditProfile', loadable(() => import(/* webpackChunkName: "EditProfile" */'@dtcm/ui-components/dist/components/Login/EditProfile')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Login', loadable(() => import(/* webpackChunkName: "Login" */'@dtcm/ui-components/dist/components/Login/Login')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('NewPassword', loadable(() => import(/* webpackChunkName: "NewPassword" */'@dtcm/ui-components/dist/components/Login/NewPassword')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('RegisterAuthentication', loadable(() => import(/* webpackChunkName: "RegisterAuthentication" */'@dtcm/ui-components/dist/components/Login/RegisterAuthentication')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('ResetPassword', loadable(() => import(/* webpackChunkName: "ResetPassword" */'@dtcm/ui-components/dist/components/Login/ResetPassword')))
components.set('MainText', MainText);
components.set('ManagedWidget', ManagedWidget);
components.set('MultifunctionalCards', MultifunctionalCards);
components.set('PopularCuisines', PopularCuisines);
components.set('RecommendationListing', RecommendationListing);
components.set('RedirectToReturnUrl', RedirectToReturnUrl);
components.set('RestaurantsCarousel', RestaurantsCarousel);
components.set('RestaurantsHeadingAndContentBlock', RestaurantsHeadingAndContentBlock);
components.set('RestaurantsListing', RestaurantsListing);
components.set('RestaurantsNavigation', RestaurantsNavigation);
components.set('RestaurantsSmallBanner', RestaurantsSmallBanner);
components.set('RichTextBubble', RichTextBubble);
components.set('SchemaSnippet', SchemaSnippet);
components.set('ScrollToBlock', ScrollToBlock);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Search', loadable(() => import(/* webpackChunkName: "Search" */'@dtcm/ui-components/dist/components/Search/Search')))
components.set('SearchRestaurants', SearchRestaurants);
components.set('SharedChannelsBreadcrumb', SharedChannelsBreadcrumb);
components.set('SharedChannelsCarousel', SharedChannelsCarousel);
components.set('SharedChannelsListing', SharedChannelsListing);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('Sitemap', loadable(() => import(/* webpackChunkName: "Sitemap" */'@dtcm/ui-components/dist/components/Sitemap/Sitemap')))
components.set('SkipContentButtons', SkipContentButtons);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('SoftixThankYou', loadable(() => import(/* webpackChunkName: "SoftixThankYou" */'@dtcm/ui-components/dist/components/SoftixThankYou/SoftixThankYou')))
components.set('SurpriseMeForm', SurpriseMeForm);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('TicketPurchase', loadable(() => import(/* webpackChunkName: "TicketPurchase" */'@dtcm/ui-components/dist/components/TicketPurchase/TicketPurchase')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('TicketsPurchases', loadable(() => import(/* webpackChunkName: "TicketsPurchases" */'@dtcm/ui-components/dist/components/TicketsPurchases/TicketsPurchases')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('TopPicks', loadable(() => import(/* webpackChunkName: "TopPicks" */'@dtcm/ui-components/dist/components/TopPicks/TopPicks')))
components.set('UnbelievableSummerDeals', UnbelievableSummerDeals);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('VenueBlock', loadable(() => import(/* webpackChunkName: "VenueBlock" */'@dtcm/ui-components/dist/components/VenueBlock/VenueBlock')))
components.set('VenueHeader', VenueHeader);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('VenueKeyStats', loadable(() => import(/* webpackChunkName: "VenueKeyStats" */'@dtcm/ui-components/dist/components/VenueKeyStats/VenueKeyStats')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('VenueShortlist', loadable(() => import(/* webpackChunkName: "VenueShortlist" */'@dtcm/ui-components/dist/components/VenueShortlist/VenueShortlist')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('VenueTable', loadable(() => import(/* webpackChunkName: "VenueTable" */'@dtcm/ui-components/dist/components/VenueTable/VenueTable')))
components.set('VideoScriptGenerator', VideoScriptGenerator);
components.set('WeatherWidget', WeatherWidget);

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('YourTicketsPurchases', loadable(() => import(/* webpackChunkName: "YourTicketsPurchases" */'@dtcm/ui-components/dist/components/YourTicketsPurchases/YourTicketsPurchases')))

// NOTE: 'import' paths _must_ be static in order for webpack to be able to analyze them at build time.
components.set('YourTopPicks', loadable(() => import(/* webpackChunkName: "YourTopPicks" */'@dtcm/ui-components/dist/components/YourTopPicks/YourTopPicks')))

// </auto-generated-imports>

components.set('GenericSecondaryHeader', HeaderGenericSecondary);

export default function componentFactory(componentName: string) {
  if (!components.has(componentName) && componentName.match(/Container$/)) {
    return components.get('CommonPageContainer');
  }

  return components.get(componentName);
}
